// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"da37bbd4eb29ca577c2b","532":"451464f95f2c28a1a040","589":"155f7906888c2eaea626","678":"521451880d0de876e4e9","883":"6b10a2a6137675cd71b5"}[chunkId] + ".js";
};